import React from 'react';
import {
    ServiceP,
    ServicesCard,
    ServicesContainer,
    ServicesH1,
    ServicesH2,
    ThreeWrapper
} from "./FormsElements";

const FormsExtensionsDetails = () => {
    return (
        <>
        <ServicesContainer id='formsExtensions'>
            <ServicesH1>Tax Extension Forms</ServicesH1>
            <ThreeWrapper>
                <ServicesCard>
                    <ServicesH2>Form 7004</ServicesH2>
                    <ServiceP>Extension of Time To File Certain Business Income Tax, Information, and Other Returns
                    </ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>Form 4868</ServicesH2>
                    <ServiceP>Application for Automatic Extension of Time To File U.S. Individual Income Tax Return
                    </ServiceP>
                </ServicesCard>
                <ServicesCard>
                    <ServicesH2>Form 8868</ServicesH2>
                    <ServiceP>Application for Automatic Extension of Time To File an Exempt Organization Return</ServiceP>
                </ServicesCard>
            </ThreeWrapper>
            <ThreeWrapper>
            <ServicesCard>
                <ServicesH2>Form 8809</ServicesH2>
                <ServiceP>Application for Extension of Time To File Information Returns
                </ServiceP>
            </ServicesCard>
            <ServicesCard>
                <ServicesH2>Form 15397</ServicesH2>
                <ServiceP>Application for Extension of Time to Furnish Recipient Statements
                </ServiceP>
            </ServicesCard>
            </ThreeWrapper>
        </ServicesContainer>
        </>
    );
};

export default FormsExtensionsDetails;
